module.exports = __webpack_public_path__ + "img/reve.57a94214.jpg";